<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 15 10"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.24765 9.65827C7.84983 10.1061 7.15017 10.1061 6.75235 9.65827L0.31784 2.41409C-0.255053 1.76911 0.202818 0.750003 1.06549 0.750003L13.9345 0.750002C14.7972 0.750002 15.255 1.76911 14.6822 2.41409L8.24765 9.65827Z" :fill="fill"/>
  </svg>
</template>

<script>
export default {
  name: 'ScrollArrowDown',
  props: {
    width: {
      type: String,
      required: false,
      default: '15'
    },
    height: {
      type: String,
      required: false,
      default: '10'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#222222'
    },
  },
};

</script>
